<template>
    <v-container fluid class="admin-page">
        <!-- Header -->
        <div class="page-header">
            <div>
                <p class="page-kicker">Administration</p>
                <h1 class="page-title">Nouvel utilisateur</h1>
                <p class="page-subtitle">Un mot de passe sera généré et envoyé par email à l'utilisateur.</p>
            </div>
            <v-btn variant="outlined" class="action-button" @click="goBack">
                <v-icon start>mdi-arrow-left</v-icon> Retour
            </v-btn>
        </div>

        <v-card variant="outlined" class="section-card">
            <div class="section-card-header">
                <v-avatar size="34" color="#dcfce7" class="section-icon">
                    <v-icon color="#059669">mdi-account-plus-outline</v-icon>
                </v-avatar>
                <div>
                    <h2 class="section-title">Informations personnelles</h2>
                    <p class="section-subtitle">Identité, structure et profil du nouvel utilisateur</p>
                </div>
            </div>

            <v-divider></v-divider>

            <div class="section-card-body">
                <v-form @submit.prevent="createUser">
                    <user-fields :fields="fields" :errors="errors" :isLoading="isLoading" @load="loadingChange" />
                    <div class="my-2"></div>
                    <div class="form-actions">
                        <v-btn type="submit" theme="dark" color="#4f46e5" class="submit-button" :loading="isLoading">
                            <v-icon start>mdi-content-save-outline</v-icon> Enregistrer
                        </v-btn>
                        <v-btn type="reset" variant="outlined" color="#dc2626" class="submit-button" @click="goBack">
                            Annuler
                        </v-btn>
                    </div>
                </v-form>
            </div>
        </v-card>

        <v-overlay :model-value="isLoading" class="align-center justify-center" z-index="6">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import UserFields from '../../../components/User/UserFields.vue';

export default {
    name: 'UserCreate',
    components: { UserFields },
    data() {
        return {
            isLoading: false,
            fields: {
                prenom: '',
                nom: '',
                matricule: '',
                email: '',
                etablissement: '',
                role: ''
            },
            errors: {
                prenom: '',
                nom: '',
                matricule: '',
                email: '',
                etablissement: '',
                role: ''
            }
        };
    },
    methods: {
        createUser() {
            this.isLoading = true;
            axios
                .post('/users', { ...this.fields, etablissement_id: this.fields.etablissement.id })
                .then((response) => {
                    if (response.data.success == true) {
                        this.$swal({
                            icon: 'success',
                            title: 'Opération réussie',
                            text: response.data.message
                        });
                        this.$router.push({ name: 'UserIndex' });
                    } else {
                        this.$swal({
                            icon: 'error',
                            title: 'Erreur !',
                            text: response.data.message
                        });
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Erreur !',
                        text: error.message
                    });
                    if (error.errors != undefined) {
                        Object.keys(this.errors).forEach((key) => {
                            this.errors[key] = error.errors[key] !== undefined ? error.errors[key][0] : '';
                        });
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        goBack() {
            this.$router.go(-1);
        },
        loadingChange(load) {
            this.isLoading = load;
        }
    }
};
</script>

<style scoped>
.admin-page {
    max-width: 100%;
}
.page-header {
    align-items: center;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    margin-bottom: 12px;
}
.page-kicker {
    color: #64748b;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 4px;
    text-transform: uppercase;
}
.page-title {
    color: #0f172a;
    font-size: 1.3rem;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 1.2;
    margin: 0;
}
.theme--dark .page-title {
    color: #f8fafc;
}
.page-subtitle {
    color: #64748b;
    font-size: 0.9rem;
    margin: 4px 0 0;
}
.action-button {
    border-radius: 8px;
    box-shadow: none;
    height: 36px;
    text-transform: none;
}
.section-card {
    border-radius: 12px;
}
.section-card-header {
    align-items: center;
    display: flex;
    gap: 16px;
    padding: 12px 16px;
}
.section-title {
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.3;
    margin: 0;
}
.section-subtitle {
    color: #64748b;
    font-size: 0.85rem;
    margin: 2px 0 0;
}
.section-card-body {
    padding: 16px;
}
.form-actions {
    display: flex;
    gap: 12px;
}
.submit-button {
    border-radius: 8px;
    box-shadow: none;
    height: 38px;
    padding: 0 24px;
    text-transform: none;
}
@media (max-width: 900px) {
    .page-header {
        align-items: stretch;
        flex-direction: column;
    }
}
</style>
